(() => {
  const getImages = (slider) => {
    return Array.from(
      slider.querySelectorAll('[data-slider-image]')
    );
  };

  const showImage = (slider, requestedIndex) => {
    const images = getImages(slider);

    if (!images.length) return;

    let index = requestedIndex;

    if (index < 0) {
      index = images.length - 1;
    }

    if (index >= images.length) {
      index = 0;
    }

    const imageData = images[index];
    const activeImage = slider.querySelector(
      '.product-card__image-slider-active'
    );

    if (!activeImage || !imageData) return;

    activeImage.src = imageData.dataset.src;
    activeImage.alt = imageData.dataset.alt || '';

    slider.dataset.currentIndex = index;
    slider.classList.add('is-active');
  };

  document.addEventListener('click', (event) => {
    const previousButton = event.target.closest(
      '[data-slider-prev]'
    );

    const nextButton = event.target.closest(
      '[data-slider-next]'
    );

    if (!previousButton && !nextButton) return;

    event.preventDefault();
    event.stopPropagation();

    const slider = event.target.closest(
      '[data-product-image-slider]'
    );

    if (!slider) return;

    const currentIndex = parseInt(
      slider.dataset.currentIndex || '0',
      10
    );

    if (previousButton) {
      showImage(slider, currentIndex - 1);
    }

    if (nextButton) {
      showImage(slider, currentIndex + 1);
    }
  });

  let touchStartX = 0;
  let touchStartY = 0;

  document.addEventListener(
    'touchstart',
    (event) => {
      const slider = event.target.closest(
        '[data-product-image-slider]'
      );

      if (!slider) return;

      const touch = event.changedTouches[0];

      touchStartX = touch.clientX;
      touchStartY = touch.clientY;
    },
    { passive: true }
  );

  document.addEventListener(
    'touchend',
    (event) => {
      const figure = event.target.closest(
        '.product-card__figure'
      );

      if (!figure) return;

      const slider = figure.querySelector(
        '[data-product-image-slider]'
      );

      if (!slider) return;

      const touch = event.changedTouches[0];

      const differenceX =
        touch.clientX - touchStartX;

      const differenceY =
        touch.clientY - touchStartY;

      if (
        Math.abs(differenceX) < 40 ||
        Math.abs(differenceX) <= Math.abs(differenceY)
      ) {
        return;
      }

      event.preventDefault();

      const currentIndex = parseInt(
        slider.dataset.currentIndex || '0',
        10
      );

      if (differenceX < 0) {
        showImage(slider, currentIndex + 1);
      } else {
        showImage(slider, currentIndex - 1);
      }
    },
    { passive: false }
  );
})();